<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.discounts') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <!-- <pre>{{ products }}</pre> -->

      <template v-if="ready">
        <section class="choose-type">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.selecttype')"/>
            <div class="row wrapper">
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.discount_type"
                    color="#A3CA76"
                    vsValue="general"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.discountgeneral') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.discountgeneraldetail') }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.discount_type"
                    color="#A3CA76"
                    vsValue="conditional"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.discountcondition') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.discountconditiondetail') }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.discount_name') }} *</label>
                    <input
                      ref="discount_name"
                      :class="[class_.discount_name]"
                      v-model="form.discount_name"
                      type="text"
                      class="form-control discount-name"
                      @keyup="onKeyUpDiscountName">
                  </div>
                </div>
              </div>
              <div
                v-if="form.discount_type === 'general'"
                class="col">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.discount_amount') }} *</label>
                    <div class="input-group">
                      <input
                        ref="amount"
                        :class="[class_.amount]"
                        v-model="form.amount"
                        type="text"
                        class="form-control text-right text-select-all"
                        style="border-right: 0;"
                        @keypress="numberOnly"
                        @keyup="form.amount = setToValidNumber(form.amount)"
                        @blur="form.amount = setToCustomDigitsNumber(form.amount)">
                      <div class="input-group-prepend">
                        <button
                          class="btn dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style="border: 1px solid #ced4da;">
                          <template v-if="form.type == 'percentage'">
                            %
                          </template>
                          <template v-if="form.type == 'number'">
                            {{ currency }}
                          </template>
                        </button>
                        <div class="dropdown-menu">
                          <a
                            class="dropdown-item"
                            @click="form.type = 'percentage'">%</a>
                          <a
                            class="dropdown-item"
                            @click="form.type = 'number'">{{ currency }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="form.discount_type === 'conditional'"
              class="form-row mt-2">
              <div class="col-md-12">
                <label>{{ $t('message.discount_amount') }} *</label>
                <div class="form-group row mb-0 no-margin">
                  <DiscountCondition
                    v-model="conditions"
                    page="new"/>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          v-if="items.length > 0 && form.discount_name"
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems') + ' ('+assignitems.length+')'"/>
            <div class="col-md-12 row align-items-center no-padding no-margin subheader-assign">
              <div class="col no-padding">{{ $t('message.productlist') }}</div>
            </div>
            <div
              v-for="(item, index) in items"
              :class="{ active: item.active}"
              class="col-md-12 row align-items-center no-padding no-margin item"
              @click="toggleAssign(item)">
              <div class="col">
                {{ item.product_name }}
              </div>
              <div class="col text-right">
                <span
                  v-for="(_item, index) in item.discounts"
                  class="comma">
                  {{ _item.discount_name }}
                </span>
                <span v-if="item.active">
                  {{ form.discount_name }}
                </span>
                <i class="fas fa-check-circle"/>
                <i class="far fa-circle"/>
              </div>
            </div>
          </div>
        </section>

        <section class="mt-4">
          <div class="col-md-12 no-padding">
            {{ $t('message.applyitemtopos', {item: $t('sidebar.discounts')}) }}
            <a
              href="https://www.treesoft.io/th/manual/product#discount"
              target="_blank">
              {{ $t('button.learnmore') }}
              <i class="fas fa-external-link-alt"/>
            </a>
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" @click="clearForm()">{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              @click="save()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import DiscountCondition from '@/components/custom/DiscountCondition.vue'
import discardFormMixin from '@/mixins/discardForm'

export default {
  name: 'DiscountNew',

  components: {
    DiscountCondition,
  },

  mixins: [discardFormMixin],

  data () {
    return {
      ready: false,

      form: {
        discount_name: '',
        discount_type: 'general',
        amount: '0',
        type: 'percentage',
      },

      items: [],
      assignitems: [],

      class_: {
        discount_name: null,
        amount: null,
      },

      conditions: [],
    }
  },
  computed: Object.assign(mapGetters({
    products: 'getProducts',
    currency: 'getCurrency',
  }), {
    newDiscount () {
      let data = {
        discount_name: this.form.discount_name,
      }

      if (this.form.discount_type === 'general') {
        data['type'] = 'general'
        data['value_type'] = this.form.type
        data['value_amount'] = parseFloat(this.form.amount)
      } else {
        data['type'] = 'conditional'
        data['conditions'] = this.filterConditions
      }

      if (this.assignitems.length > 0) {
        data['assign'] = this.assignitems
      }
      return data
    },
    IsValidform () {
      if (this.form.discount_name.trim().length == 0) {
        this.class_.discount_name = 'is-invalid'
        this.$refs.discount_name.focus()
      }
      return this.class_.discount_name == null && this.class_.amount == null
    },
    filterConditions () {
      return this.conditions.filter((item) => {
        if (item.quantity === null || item.value_amount === null) {
          return false
        }
        return true
      })
        .map((item) => {
          return {
            ...item,
            quantity: parseFloat(item.quantity),
            value_amount: parseFloat(item.value_amount),
          }
        })
    },
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    items: {
      handler: function (after) {
        let items = after
        this.updateAssignItems(items)
      },
      deep: true,
    },
    'form.amount': {
      handler: function () {
        if (this.form.amount.trim().length > 0) {
          this.class_.amount = null
        } else {
          this.class_.amount = 'is-invalid'
        }
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    // get products
    await this.$store.dispatch('getProducts')
    // set amount
    this.form.amount = this.setToCustomDigitsNumber(this.form.amount)
    // set items
    this.setItems(null, this.products)
    // update assignitems
    this.updateAssignItems(this.items)
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 1,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },
  methods: {
    clearForm () {
      this.ready = false

      this.form.discount_name = ''
      this.form.type = 'percentage'
      this.setItems(null, this.products)

      this.class_.discount_name = null
      this.class_.amount = null

      setTimeout(() => {
        this.ready = true
      }, 1)
    },
    async save () {
      if (!this.IsValidform) {
        return false
      }

      let res = await this.$store.dispatch('insertDiscount', this.newDiscount)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: this.form.discount_name }),
          color: 'success',
          icon: 'cloud',
        })
        // go to GoodsIssueAll page
        return this.$router.push({
          name: 'DiscountAll',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
    toggleAssign (item) {
      if (this.form.discount_name.trim().length == 0) {
        this.form.discount_name = ''
        return $(this.$refs.discount_name).focus().addClass('is-invalid')
      }
      item.active = !item.active
    },
    setItems (discount, products) {
      this.items = []
      for (let i in products) {
        let product = products[i]
        var active = false
        if (discount) {
          for (let j in product.discounts) {
            let item = product.discounts[j]
            if (discount.discount_id == item.discount_id) {
              active = true
            }
          }
        }
        this.items.push({
          product_id: product.product_id,
          product_name: product.product_name,
          discounts: product.discounts,
          active: active,
        })
      }
    },
    updateAssignItems (items) {
      this.assignitems = []
      for (let i in items) {
        let item = items[i]
        if (item.active) {
          this.assignitems.push({
            product_id: item.product_id,
          })
        }
      }
    },
    onKeyUpDiscountName () {
      if (this.form.discount_name.trim().length > 0) {
        this.class_.discount_name = null
      } else {
        this.class_.discount_name = 'is-invalid'
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/discount/New.vue